import { useQuery } from "@tanstack/react-query";

import specialistCore from "../../core/specialist.core";

export function useSpecialists(type: string) {
  return useQuery({
    queryFn: () => specialistCore.listSpecialists(type),
    queryKey: ["Specialists", type],
  });
}
